/**
 * Group together redirects in this file. This file is small enough that it's
 * probably not worth lazy loading.
 * 
 * These are URLs that we've decided in the past still need to be supported,
 * but they have a new canonical destination. Some are still hosted on this
 * website, some are now hosted on Google infrastructure.
 */
import {Component} from 'inferno'; // eslint-disable-line no-unused-vars

import {Page} from '../common/components';

export class ContactPageRedirect extends Page {
    pageInit() {
        this.redirect(this.context.GOOGLE_CONTACT_URL);
    }
}

export class LegalTermsDeveloperUpdateRedirect extends Page {
    pageInit() {
        this.redirect(this.fullURL('/gifapi/documentation#apiterms'));
    }
}

export class AboutFAQPageRedirect extends Page {
    pageInit() {
        this.redirect('https://support.google.com/tenor');
    }
}

export class LegalTermsUpdateRedirect extends Page {
    pageInit() {
        const localizeUrlPath = this.context.gtService.localizeUrlPath;
        this.redirect(this.fullURL(localizeUrlPath('/legal-terms')));
    }
}

/**
 * Frank had us set this up, it's linked to from an LG product.
 */
export class LegalPrivacyRedirect extends Page {
    pageInit() {
        this.redirect(this.context.GOOGLE_PP_URL);
    }
}
